import React from 'react';
import { motion } from 'framer-motion';
export function ValueSection() {
  return <section className="bg-cream py-20 px-4" data-id="element-289">
      <div className="max-w-4xl mx-auto" data-id="element-290">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-291">
          ¿Cuánto vale realmente esta información?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-soft overflow-hidden border border-soft-gray mb-10" data-id="element-292">
          <div className="overflow-x-auto" data-id="element-293">
            <table className="w-full text-left border-collapse" data-id="element-294">
              <thead data-id="element-295">
                <tr className="bg-navy text-white" data-id="element-296">
                  <th className="p-4 font-semibold text-lg" data-id="element-297">
                    Si buscaras esta ayuda por otro lado
                  </th>
                  <th className="p-4 font-semibold text-lg text-right" data-id="element-298">
                    Costo aproximado
                  </th>
                </tr>
              </thead>
              <tbody className="text-navy/80" data-id="element-299">
                <tr className="border-b border-soft-gray" data-id="element-300">
                  <td className="p-4" data-id="element-301">
                    Consulta con especialista en sueño infantil
                  </td>
                  <td className="p-4 text-right font-medium" data-id="element-302">
                    $60.000 a $150.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray" data-id="element-303">
                  <td className="p-4" data-id="element-304">
                    Asesoría de sueño personalizada (3 sesiones)
                  </td>
                  <td className="p-4 text-right font-medium" data-id="element-305">
                    $90.000 a $200.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray" data-id="element-306">
                  <td className="p-4" data-id="element-307">Libros importados especializados (x3)</td>
                  <td className="p-4 text-right font-medium" data-id="element-308">
                    $40.000 a $80.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray bg-red-50/50" data-id="element-309">
                  <td className="p-4" data-id="element-310">
                    Semanas de prueba y error sin información
                  </td>
                  <td className="p-4 text-right font-bold text-red-500" data-id="element-311">
                    Incalculable en agotamiento
                  </td>
                </tr>
                <tr className="bg-sky/10 font-bold text-navy text-lg" data-id="element-312">
                  <td className="p-4" data-id="element-313">Método Noches de Paz™ completo</td>
                  <td className="p-4 text-right" data-id="element-314">$19.990</td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-xl text-navy font-medium max-w-2xl mx-auto" data-id="element-315">
          Por menos de lo que cuesta una sola consulta, tenés acceso a un
          sistema completo que podés aplicar esta misma noche.
        </motion.p>
      </div>
    </section>;
}